import { awaitAuthReady } from "@appally/lib/data/firebase";
import { ReactNode, useEffect, useState } from "react";
import Loader from "./Loader";

type AuthReadyGateProps = {
  children: ReactNode;
};

export const AuthReadyGate = ({ children }: AuthReadyGateProps) => {
  const [isAuthReady, setIsAuthReady] = useState(false);

  useEffect(() => {
    let isMounted = true;

    awaitAuthReady().finally(() => {
      if (isMounted) setIsAuthReady(true);
    });

    return () => {
      isMounted = false;
    };
  }, []);

  if (!isAuthReady) return <Loader />;

  return <>{children}</>;
};
